<div class="wrapper wrapper-content mtv-parcels-page row">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="parkingPassService.showDetailedView"
         [ngStyle]="{width: parkingPassService.showDetailedView ? 'calc(100% - 420px)' : '100%'}">
        <div class="ibox-content no-scroll-mode">
            <div class="row" *ngIf="!authenticationService.userIsResident || !parkingPassService.limits.length">
                <div class="col-sm-7">
                    <filter [tabHeading]="'Parking Pass'" [buildings]="parkingPassService.buildingsForRead"></filter>
                </div>

                <parking-passes-filter *ngIf="!authenticationService.userIsResident"></parking-passes-filter>
                <div *ngIf="parkingPassService.canEdit()" class="col-sm-3">
                    <button type="button" *ngIf="parkingPassService.residentParkinglots.length > 0 || !authenticationService.userIsResident"
                            class="btn btn-w-m btn-primary pull-right"
                            (click)="parkingPassService.isParkingPassModalShow = true"
                            [disabled]="!parkingPassService.buildings.length && !authenticationService.userIsResident">
                        <i class="fa fa-plus-circle"></i> New Pass
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <filters-view></filters-view>
                </div>
            </div>
            <div *ngIf="authenticationService.userIsResident && parkingPassService.limits.length">
                <div class="row">
                    <div class="col-md-12 month-header">
                        <span>{{currentMonth}} pass count</span>
                    </div>
                </div>
                <div class="row pp_header">
                    <div class="col-xs-12 col-sm-4" >
                        <div class="m_wrap">
                            <div class="dx">
                                <div class="xc" *ngFor="let element of parkingPassService.limits ">
                                    <div class="row pas_box">
                                        <div class="column_left">{{element.passTypeName}} Left</div>
                                        <div class="column_right nav-block_lable mtv-primary-color">
                                            {{element.limits}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-8">
                        <div class="col-sm-9 search_input">
                            <filter [tabHeading]="'Parking Pass'" [buildings]="parkingPassService.buildingsForRead"></filter>
                        </div>

                        <div *ngIf="parkingPassService.canEdit()" class="create_btn">
                            <button type="button" class="btn btn-w-m btn-primary pull-right"
                                    (click)="parkingPassService.isParkingPassModalShow = true"
                                    *ngIf="parkingPassService.residentParkinglots.length > 0">
                                <i class="fa fa-plus-circle"></i> New Pass
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allParkingPasses'" [ngClass]="{'sk-loading': parkingPassService.spinnerShow}">
                    <parking-pass-list></parking-pass-list>
                </tab-item>
                <pagination *ngIf="parkingPassService.data.allParkingPasses.total && urlService.queryParams['page']"
                            [total]="parkingPassService.data['allParkingPasses'].total">
                </pagination>
                <spinner [spinnerShow]="parkingPassService.spinnerShow"></spinner>
            </tabs-wrapper>
        </div>
    </div>
    <div class="animated animated-directory slideInRight detailed-view dv-sidebar">
        <parking-pass-detailed-view *ngIf="parkingPassService.showDetailedView"></parking-pass-detailed-view>
    </div>
</div>

<parking-pass-modal *ngIf="parkingPassService.isParkingPassModalShow"></parking-pass-modal>
<parking-pass-payment *ngIf="parkingPassService.isPaymentModalShow"></parking-pass-payment>
<parking-pass-view *ngIf="parkingPassService.isViewModalShow"></parking-pass-view>



// WEBPACK FOOTER //
// /app/src/app/views/parking-pass/parking-pass.component.html